import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, ensureCsrf } from "@/lib/api";

const SiteCtx = createContext({ site: null, catalog: null });

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const [catalog, setCatalog] = useState(null);
  const load = useCallback(() => {
    api.get("/public/site").then((r) => setSite(r.data)).catch(() => setSite({}));
    api.get("/public/catalog").then((r) => setCatalog(r.data)).catch(() => setCatalog({ categories: [], treatments: [] }));
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  return <SiteCtx.Provider value={{ site, catalog, reload: load }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try {
      await ensureCsrf();
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(false);
    }
  }, []);
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };
  const can = (perm) => !!user && (user.permissions.includes("*") || user.permissions.includes(perm));
  return <AuthCtx.Provider value={{ user, setUser, refresh, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
